import {
  bookingsIcon,
  downloadIcon,
  filterIcon,
  invoiceIcon,
  tableShortingIcon,
} from "assets/icons";
import {
  Button,
  DatePicker,
  LoadingButton,
  Select,
  TextArea,
} from "components/form";
import CustomModal from "components/modals/CustomModal";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { IoSearchOutline } from "react-icons/io5";
import { CgArrowsExchangeV } from "react-icons/cg";
import { Link } from "react-router-dom";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import {
  exportOrderAPI,
  getCardDataAPI,
  getOrderListAPI,
  getOrderStatusAPI,
  getWaitReconciliationAPI,
  statusToggleAPI,
} from "services/user-controllers/order-controller";
import TableHead from "components/table/TableHead";
import {
  filterOperatorDropdown,
  generateId,
  myOrderFilterColumns,
} from "../myOrders/order-config/orderConfig";
import TableBody from "components/table/TableBody";
import { toast } from "react-toastify";
import FilterModal from "components/filter/FilterModal";
import ColumnFilterDropdown from "components/filter/ColumnFilterDropdown";
import Pagination from "react-js-pagination";
import useDebounce from "hooks/useDebounce";
import moment from "moment";
import { FaArrowDown, FaArrowUp } from "react-icons/fa6";
import { waitReconciliationFilterColumns } from "./waitDisConfig";

const WeightDiscrepancies = () => {
  const [additionalChargeData, setAdditionalChargeData] = useState(undefined);
  const [isAdditionalModalOpen, setIsAdditionalModalOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [chat, setChat] = useState(false);
  const [accept, setAccept] = useState(false);
  const [dispute, setDispute] = useState(false);
  const [isAdditionalBlank, setIsAdditionalBlank] = useState(false);

  //  setAdditionalHandler
  const setAdditionalChargeHandler = (charge) => {
    console.log("I AM ADDITIONAL CHARGE", charge);
    if (charge === "{}") {
      setIsAdditionalBlank(true);
    } else {
      let additionalData = {};
      let parsedAdditionalData = JSON?.parse(charge);
      additionalData = parsedAdditionalData;
      setIsAdditionalBlank(false);
      setAdditionalChargeData(additionalData);
    }
    setIsAdditionalModalOpen(true);
  };

  // Columns filter listing data
  const waitReconciliationColumns = [
    {
      sort: "DESC",
      enable: true,
      key: "Order_id",
      name: "Order ID",
      icon: <FaArrowUp />,
    },
    {
      sort: "DESC",
      enable: true,
      icon: <FaArrowUp />,
      key: "shipmentDetails",
      name: "Shipment Details",
      formatHandler: (item, col) => {
        return <td key={col?.key}>{item?.order?.Itemname || "----"}</td>;
      },
    },
    {
      enable: true,
      key: "mVikasDocketNo",
      name: "MVikas Docket No.",
      formatHandler: (item, col) => {
        return <td key={col?.key}>{item?.order?.MvikasDocketNo || "----"}</td>;
      },
    },
    {
      sort: "DESC",
      enable: true,
      key: "articles",
      icon: <FaArrowUp />,
      name: "No. of Boxes",
    },
    {
      sort: "DESC",
      enable: true,
      icon: <FaArrowUp />,
      name: "Charged Weight",
      key: "chargable_weight",
    },
    {
      sort: "DESC",
      enable: true,
      icon: <FaArrowUp />,
      key: "excess_weight",
      name: "Excess Weight",
    },
    {
      sort: "DESC",
      enable: true,
      icon: <FaArrowUp />,
      key: "serviceApplied",
      name: "Service Applied",
      formatHandler: (item, col) => {
        return <td key={col?.key}>{item?.service?.name || "----"}</td>;
      },
    },
    {
      sort: "DESC",
      enable: true,
      icon: <FaArrowUp />,
      key: "newServiceApplied",
      name: "New Service Applied",
      formatHandler: (item, col) => {
        return <td key={col?.key}>{item?.serviceNew?.name || "----"}</td>;
      },
    },
    {
      sort: "DESC",
      enable: true,
      key: "new_weight",
      icon: <FaArrowUp />,
      name: "New Applied Weight",
    },
    {
      sort: "DESC",
      enable: true,
      key: "totalAmount",
      icon: <FaArrowUp />,
      name: "Total Amount",
    },
    {
      sort: "DESC",
      enable: true,
      icon: <FaArrowUp />,
      key: "updatedAt",
      name: "Status Updated On",
      formatHandler: (item, col) => {
        return (
          <td key={col?.key}>
            {moment(item?.updatedAt).format("DMMM, YYYY") || "-----"}
          </td>
        );
      },
    },
    {
      key: "rate",
      // sort: "DESC",
      name: "Status",
      enable: true,
      // icon: <FaArrowUp />,
      formatHandler: function (item, col) {
        if (item?.status === 1) {
          return (
            <td key={col.key}>
              <Button className="tag orange">Requested</Button>
            </td>
          );
        } else {
          if (item?.status === 4 || item?.status === 5) {
            return (
              <td key={col.key}>
                <Button className="tag green">Accepted</Button>
              </td>
            );
          } else if (item?.status === 2 || item?.status === 3) {
            return (
              <td key={col.key}>
                <Button className="tag red">Rejected</Button>
              </td>
            );
          } else {
            return (
              <td key={col.key}>
                <Button className="tag">------</Button>
              </td>
            );
          }
        }
      },
    },
    {
      // sort: "DESC",
      enable: true,
      key: "oda_amount",
      name: "Remark",
      // icon: <FaArrowUp />,
      formatHandler: function (item, col) {
        return (
          <td key={col.key}>
            <Button
              onClick={() => {
                viewRemarkHandler(item);
              }}
              className="tag button"
            >
              View
            </Button>
          </td>
        );
      },
    },

    {
      enable: true,
      key: "additionalCharges",
      name: "Action",
      formatHandler: function (item, col) {
        return (
          <td key={col.key}>
            <div className="button_wrap wrap_padding_remove">
              <Button
                disabled={
                  item?.status === 1 || item?.status === 3 ? false : true
                }
                className={
                  item?.status === 1 || item?.status === 3
                    ? "tag button"
                    : "disabled tag button"
                }
                onClick={() => {
                  setWeightId(item?.id);
                  setAccept(true);
                }}
              >
                Accept
              </Button>
              <Button
                disabled={
                  item?.status === 1 || item?.status === 3 ? false : true
                }
                onClick={() => {
                  setWeightId(item?.id);
                  setDispute(true);
                }}
                className={
                  item?.status === 1 || item?.status === 3
                    ? "tag button"
                    : "disabled tag button"
                }
              >
                Dispute
              </Button>
            </div>
          </td>
        );
      },
    },
  ].filter((column) => column.enable);

  //***************************** Handle all state ***************************//
  const [orderID, setOrderID] = useState("");
  const [totalRecord, setTotalRecord] = useState(0);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [waitReconciliationList, setWaitReconciliationList] = useState([]);
  const [statusList, setStatusList] = useState([]);

  const [cardsData, setCardsData] = useState({});

  const [processedColumnsArray, setProcessedColumnsArray] = useState(
    waitReconciliationColumns
  );
  const [togglerSwitch, setTogglerSwitch] = useState(false);

  const [selfAuthId, setSelfAuthId] = useState("");
  const [remarkListForModal, setRemarkListForModal] = useState([]);
  //------------------- Accept and Reject Functions State ---------------//
  const [weightId, setWeightId] = useState("");
  const [weightRemark, setWeightRemark] = useState("");
  const [actionButtonLoading, setActionButtonLoading] = useState(false);

  //---- state for handle sorting----//
  const [sortingToggler, setSortingToggler] = useState(false);
  const [sortingFilterField, setSortingFilterField] = useState({
    isSortApply: 0,
    sortColumnName: "",
    sortingOrder: "",
  });

  //------- handle all filter state ---------//

  const [limitRow, setLimitRow] = useState(5);
  const [activePage, setActivePage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [startDateFilter, setStartDate] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [endDateFilter, setEndDateFilter] = useState("");

  const [orderStatus, setOrderStatus] = useState("");

  const [filterModalFields, setFilterModalFields] = useState({
    columnFilterName: "",
    operatorFilterName: "",
    filterValue: "",
    isApplied: false,
  });

  const statusDebounceValue = useDebounce(orderStatus, 500);
  const searchDebounceValue = useDebounce(searchValue, 500);
  const endDateDebounceValue = useDebounce(endDateFilter, 500);
  const startDateDebounceValue = useDebounce(startDateFilter, 500);

  //***************************** Handle all function ***************************//

  useEffect(() => {
    const localData = localStorage?.getItem("adminAuthDetail") || null;
    if (localData) {
      const selfId = JSON.parse(localData)?.userDetails?.userId;
      setSelfAuthId(selfId);
    }
  }, []);

  // View Remark Handler
  const viewRemarkHandler = (item) => {
    const remark = item?.remark;
    let finalRemark;
    if (remark) {
      finalRemark = JSON.parse(remark);
      let newChatList = finalRemark.map((el) => {
        return {
          ...el,
          uniqId: generateId(),
        };
      });
      console.log(newChatList);

      setRemarkListForModal(newChatList);
      setChat(true);
    }
  };

  const viewInvoiceHandler = (url) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      toast?.error("Invoice not available");
      return;
    }
  };

  const viewPODHandler = (url) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      toast?.error("POD not available");
      return;
    }
  };

  // get status list handler
  const getStatusListHandler = async () => {
    try {
      const { data } = await getOrderStatusAPI();
      if (data?.code === 200) {
        const statusList = data?.data?.map((el) => {
          return {
            ...el,
            value: el?.id,
            uniqId: generateId(),
          };
        });
        setStatusList(statusList);
      } else {
        toast.error(data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // pageChangeHandler for pagination
  const handlePageChange = (event) => {
    console.log(event);
    setActivePage(event);
  };

  //------------------ Functions for handle filter andy dynamic table columns --------------------//

  // toggleColumnVisibility handler for set array of hidden column name
  // const toggleColumnVisibility = (key) => {
  //   setHiddenColumns((prevState) =>
  //     prevState.includes(key)
  //       ? prevState.filter((col) => col !== key)
  //       : [...prevState, key]
  //   );
  // };

  const toggleColumnVisibility = (key) => {
    if (!hiddenColumns?.length) {
      let updateHidden = {
        sort: "DESC",
        icon: <FaArrowUp />,
        hiddenValue: key,
      };

      let hiddenArr = [updateHidden];
      setHiddenColumns(hiddenArr);
    } else {
      if (hiddenColumns.some((el) => el.hiddenValue === key)) {
        let updatedHiddenArray = hiddenColumns.filter(
          (el) => el.hiddenValue !== key
        );
        setHiddenColumns(updatedHiddenArray);
      } else {
        let clone = [...hiddenColumns];
        let updatedHiddenCol = {
          sort: "DESC",
          icon: <FaArrowUp />,
          hiddenValue: key,
        };
        clone = [...clone, { ...updatedHiddenCol }];
        setHiddenColumns(clone);
      }
    }
    setTogglerSwitch(!togglerSwitch);
  };

  // hideAllColumnsHandler for hide all columns of table
  // const hideAllColumns = () => {
  //   setHiddenColumns(waitReconciliationColumns.map((col) => col.key));
  // };

  const hideAllColumns = () => {
    setHiddenColumns(
      waitReconciliationColumns.map((col) => {
        return {
          sort: col.sort,
          icon: col.icon,
          hiddenValue: col?.key,
        };
      })
    );
    setTogglerSwitch(!togglerSwitch);
  };

  // Show all columns handler for show all table's data
  // const showAllColumns = () => {
  //   setHiddenColumns([]);
  // };
  const showAllColumns = () => {
    setHiddenColumns([]);
    setTogglerSwitch(!togglerSwitch);
  };

  // sort toggle Handler
  const toggleSortHandler = (keyValue, col) => {
    let index = 0;
    let updatedCol;
    let isApplied = 0;
    let sortFields = {};
    let cloneProcessedArray = processedColumnsArray?.map((el) => el);

    if (cloneProcessedArray?.length > 0) {
      updatedCol = processedColumnsArray.find((el) => el.key === keyValue);
      index = cloneProcessedArray.findIndex((obj) => obj.key === keyValue);
      if (updatedCol?.sort === "DESC") {
        updatedCol = {
          ...updatedCol,
          sort: "ASC",
          icon: <FaArrowDown />,
          isHidden: hiddenColumns.some((el) => el?.hiddenValue === keyValue),
        };
        isApplied = 1;
      } else {
        updatedCol = {
          ...updatedCol,
          sort: "DESC",
          icon: <FaArrowUp />,
          isHidden: hiddenColumns.some((el) => el?.hiddenValue === keyValue),
        };
        isApplied = 2;
      }
    }
    cloneProcessedArray[index] = updatedCol;
    setProcessedColumnsArray(cloneProcessedArray);

    if (isApplied === 1 || isApplied === 2) {
      sortFields = {
        isSortApply: isApplied,
        sortColumnName: keyValue,
        sortingIcon: updatedCol?.icon,
        sortingOrder: updatedCol?.sort,
      };
    }
    setSortingFilterField({ ...sortFields });
    setSortingToggler(!sortingToggler);
  };

  // function for set column array with there column visibility checked by check and uncheck
  // const processedColumns = waitReconciliationColumns.map((col) => ({
  //   ...col,
  //   isHidden: hiddenColumns.includes(col.key),
  // }));

  //------------------ Close Functions for handle filter andy dynamic table columns --------------------//

  // get cards data handler
  const getCardsRecordsHandler = async () => {
    try {
      const { data } = await getCardDataAPI();
      if (data?.code === 200) {
        setCardsData(data?.data);
      } else {
        toast?.error(data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // get order list handler for get order data
  const getOrderListHandler = async (
    page = activePage,
    search = searchDebounceValue,
    status = statusDebounceValue,
    fromDate = startDateDebounceValue
      ? moment(startDateDebounceValue).format("YYYY-MM-DD")
      : "",
    toDate = endDateDebounceValue
      ? moment(endDateDebounceValue).format("YYYY-MM-DD")
      : "",
    limit = limitRow,

    isSort = sortingFilterField?.isSortApply === 1 ||
    sortingFilterField?.isSortApply === 2
      ? sortingFilterField?.isSortApply
      : 0,
    sortColumnName = sortingFilterField?.isSortApply === 1 ||
    sortingFilterField?.isSortApply === 2
      ? sortingFilterField?.sortColumnName
      : "",
    sortingOrder = sortingFilterField?.isSortApply === 1 ||
    sortingFilterField?.isSortApply === 2
      ? sortingFilterField?.sortingOrder
      : "",

    column = filterModalFields?.columnFilterName,
    operator = filterModalFields?.operatorFilterName,
    value = filterModalFields?.filterValue
  ) => {
    try {
      const { data } = await getWaitReconciliationAPI(
        page,
        search,
        status,
        fromDate,
        toDate,
        limit,
        isSort,
        sortColumnName,
        sortingOrder,
        column,
        operator,
        value
      );
      console.log("WAIT RECONcialaition API RESPONSE", data);

      if (data?.code === 200) {
        setTotalRecord(data?.data?.count || 0);
        setWaitReconciliationList(data?.data?.list);
      } else {
        toast.error(data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Export Order Listing Handler
  const exportOrderListHandler = async () => {
    try {
      const response = await exportOrderAPI();
      const { data, headers } = response;

      if (response.status !== 200) {
        return toast.error("Failed to download the file.");
      }

      // Create a blob from the response data
      const blob = new Blob([data], { type: headers["content-type"] });

      // Create a link element to download the file
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);

      // Set the download attribute with a filename
      const filename =
        headers["content-disposition"]?.split("filename=")[1] || "order.xlsx";
      link.download = filename.replace(/"/g, "");

      // Append the link to the body, click it to trigger the download, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      console.log("EXPORT ORDER LISTING RESPONSE", data);
    } catch (err) {
      console.error(err);
      toast.error("Error occurred while downloading the file.");
    }
  };

  // reset-filter handler
  const resetFilterHandler = () => {
    if (filterModalFields?.columnFilterName?.length > 0) {
      setFilterModalFields({
        columnFilterName: "",
        operatorFilterName: "",
        filterValue: "",
      });
    }
  };

  // update Status Of Weight Discrepancies
  const updateWeightStatusHandler = async (e, statusValue, setLoading) => {
    e.preventDefault();
    try {
      setLoading(true);

      const sendData = {
        id: weightId,
        type: statusValue,
        remark: weightRemark,
      };

      const { data } = await statusToggleAPI(sendData);
      if (data?.code === 200) {
        setWeightId("");
        setWeightRemark("");
        setAccept(false);
        toast.success(data?.message);
        getOrderListHandler();
      } else {
        toast?.error(data?.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect for get order listing and handle filter
  useEffect(() => {
    getOrderListHandler();

    // eslint-disable-next-line
  }, [
    activePage,
    searchDebounceValue,
    statusDebounceValue,
    startDateDebounceValue,
    endDateDebounceValue,
    limitRow,
    sortingFilterField.isSortApply,
    sortingToggler,
    filterModalFields?.isApplied,
  ]);

  // useEffect for handle processed column
  useEffect(() => {
    const processedColumnHandler = () => {
      let cloneProcessed = waitReconciliationColumns.map((col) => {
        return {
          ...col,
          isHidden: hiddenColumns.some((el) => el?.hiddenValue === col.key),
        };
      });

      setProcessedColumnsArray(cloneProcessed);
    };

    processedColumnHandler();
  }, [togglerSwitch]);

  useEffect(() => {
    getStatusListHandler();
    getCardsRecordsHandler();
  }, []);

  //***************************** Handle HTML CODE ***************************//
  return (
    <>
      <div className="my_orders_list">
        <div className="dashboard_title">
          <h4>Weight Discrepancies</h4>
        </div>
        <div className="wrap_data_cards">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="card">
                <p>TOTAL DISCREPANCY</p>
                <h2>{cardsData?.totalDescrepancy || "-----"}</h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="card">
                <p>TOTAL CLOSED DISCREPANCY</p>
                <h2>{cardsData?.totalClosedDescrepancy || "-----"}</h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="card">
                <p>NEW DISCREPANCY ACCOUNT</p>
                <h2>{cardsData?.totalNewDescrepancy || "-----"}</h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="card">
                <p>DISPUTE REJECTED BY COURIER</p>
                <h2>{cardsData?.totalDisputeRejected || "-----"}</h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="card">
                <p>DISPUTE PENDING</p>
                <h2>{cardsData?.totalDisputePending || "-----"}</h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="card">
                <p>DISCREPANCY ACCEPTED</p>
                <h2>{cardsData?.totalDescrepancyAccespet || "-----"}</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="button_section">
          <div className="form_field">
            <div className="search_box">
              <IoSearchOutline />
              <input
                type="search
                  "
                value={searchValue}
                placeholder="Search"
                className="from-control input"
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
          </div>

          <div className="form_field has_icon">
            <img src={invoiceIcon} alt="" className="icon" />
            <Select
              value={orderStatus}
              onChange={(e) => setOrderStatus(e.target.value)}
            >
              <option value={""}>Order Status</option>
              <option value={""}>All</option>
              {statusList?.length > 0 &&
                statusList?.map((el) => (
                  <option key={el.uniqId} value={el?.value}>
                    {el?.name}
                  </option>
                ))}
            </Select>
          </div>

          <div className="form_field">
            <DatePicker
              placeholder="From"
              value={startDateFilter}
              onChange={(date) => setStartDate(date)}
              isClearable={startDateFilter ? true : false}
            />
          </div>
          <div className="form_field">
            <DatePicker
              placeholder="To"
              value={endDateDebounceValue}
              onChange={(date) => setEndDateFilter(date)}
              isClearable={endDateDebounceValue ? true : false}
            />
          </div>

          {/* <Button>Search</Button> */}
        </div>

        {/*----------- Handle Filter and Column filter -------------*/}
        <div className="table_filter_wrap">
          <div className="filter_buttons">
            {/*-------- handle filters dropdown --------*/}
            <Dropdown>
              <Dropdown.Toggle onClick={() => setFilterModal(true)}>
                <img src={filterIcon} alt="" />
                <span>Filters</span>
              </Dropdown.Toggle>
            </Dropdown>

            {/* handle column filter dropdown */}
            <ColumnFilterDropdown
              columnsArray={processedColumnsArray}
              onToggleColumn={toggleColumnVisibility}
              hideAllColumns={hideAllColumns}
              showAllColumns={showAllColumns}
            />

            {/* Reset Filter */}
            {filterModalFields?.isApplied && (
              <Button onClick={resetFilterHandler}>Reset Filter</Button>
            )}
          </div>

          <Button onClick={() => exportOrderListHandler()}>
            <img src={downloadIcon} alt="" /> Export
          </Button>
        </div>

        <div className="table_wrap">
          <table className="table">
            <TableHead
              sortHandler={toggleSortHandler}
              columnsArray={processedColumnsArray}
            />
            <TableBody
              listingData={waitReconciliationList}
              columnsArray={processedColumnsArray}
            />
          </table>
        </div>
        {/*-------- Handle Pagination ---------*/}
        <div className="pagination_wrapper">
          <div className="pages_count">
            <p>
              <span>Rows per pages</span>{" "}
              <Select
                value={limitRow}
                onChange={(e) => setLimitRow(e.target.value)}
              >
                <option value={5}>05</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
              </Select>
            </p>
            {/* <span className="page_tag">1-6 of 6</span> */}
          </div>
          <Pagination
            itemClass="page-item"
            linkClass="page-link"
            pageRangeDisplayed={5}
            activePage={activePage}
            // prevPageText={"Prev"}
            // nextPageText={"Next"}
            // itemClassPrev={"prev"}
            // itemClassNext={"next"}
            onChange={handlePageChange}
            itemsCountPerPage={limitRow}
            totalItemsCount={totalRecord}
            itemClassLast={"last_page next"}
            itemClassFirst={"first_page prev"}
          />
        </div>
      </div>

      {/*----------------------- Handle All Modals ---------------------*/}
      {/*---------- filter dropdown modal ------------*/}
      <CustomModal
        show={filterModal}
        className={"filterModal"}
        handleClose={() => setFilterModal(false)}
      >
        <FilterModal
          filterFields={filterModalFields}
          setModalVisibility={setFilterModal}
          operatorArray={filterOperatorDropdown}
          setFilterFields={setFilterModalFields}
          columnArray={waitReconciliationFilterColumns}
        />
      </CustomModal>

      {/* View breakup modal */}
      <CustomModal
        show={isAdditionalModalOpen}
        handleClose={() => setIsAdditionalModalOpen(false)}
        className={"view_breakup_charges_modal"}
      >
        {/* <h3>{vendorName}</h3> */}
        <ul>
          {additionalChargeData && !isAdditionalBlank ? (
            Object.keys(additionalChargeData).map((keyName, i) => (
              <li key={i}>
                <h5>{keyName}</h5>
                <h5>{additionalChargeData[keyName]}</h5>
              </li>
            ))
          ) : (
            <li className="text-center">
              <h5 className="w-100">No Addition Charges Applied.</h5>
            </li>
          )}
        </ul>
      </CustomModal>

      {/* filter dropdown modal */}
      <CustomModal
        show={show}
        className={"special_charges_modal"}
        handleClose={() => setShow(false)}
      >
        <div className="wrap_sc_status">
          <h4>Special Charges Status</h4>
          <div className="wrap_list_data">
            <div className="form_field_wrap">
              <div className="form_wrap">
                <Select name="" id="">
                  <option value="">Select Status</option>
                  <option value="">Approve</option>
                  <option value="">Decline</option>
                </Select>
              </div>
            </div>
            <div className="wrap_actions">
              <h6>Created</h6>
              <span>Action:create,By Sunil, timestamp:19/10/2024,20:12:14</span>
              <span className="cstm_dots"></span>
            </div>
          </div>
        </div>
      </CustomModal>

      {/*--------------- action Accepted modal ------------------*/}

      <CustomModal
        show={accept}
        handleClose={() => {
          setWeightId("");
          setWeightRemark("");
          setAccept(false);
        }}
        className={"special_charges_modal"}
      >
        <div className="wrap_sc_status">
          <h4>Are You Sure Want to Accept This ?</h4>
          <div className="wrap_list_data mt-4">
            <div className="form_wrap">
              <TextArea
                rows={4}
                value={weightRemark}
                placeholder="Enter here..."
                onChange={(e) => setWeightRemark(e.target.value)}
              />
            </div>
            <div className="button_wrap button_center">
              <Button
                className={"light"}
                onClick={() => {
                  setWeightId("");
                  setWeightRemark("");
                  setAccept(false);
                }}
              >
                No
              </Button>

              {/* <Button>Yes</Button> */}

              <LoadingButton
                loading={actionButtonLoading}
                disabled={actionButtonLoading}
                className={actionButtonLoading ? "disabled" : ""}
                onClick={(e) =>
                  updateWeightStatusHandler(e, "Accept", setActionButtonLoading)
                }
              >
                Yes
              </LoadingButton>
            </div>
          </div>
        </div>
      </CustomModal>

      {/*-----------------  Dispute Accepted modal ---------------*/}

      <CustomModal
        show={dispute}
        handleClose={() => {
          setWeightId("");
          setWeightRemark("");
          setDispute(false);
        }}
        className={"special_charges_modal"}
      >
        <div className="wrap_sc_status">
          <h4>Dispute</h4>
          <div className="wrap_list_data mt-4">
            <div className="form_wrap">
              <TextArea
                rows={4}
                value={weightRemark}
                placeholder="Enter here..."
                onChange={(e) => setWeightRemark(e.target.value)}
              />
            </div>
            <div className="button_wrap button_center">
              <Button
                className={"light"}
                onClick={() => {
                  setWeightId("");
                  setWeightRemark("");
                  setDispute(false);
                }}
              >
                No
              </Button>
              {/* <Button>Submit</Button> */}

              <LoadingButton
                loading={actionButtonLoading}
                disabled={actionButtonLoading}
                className={actionButtonLoading ? "disabled" : ""}
                onClick={(e) =>
                  updateWeightStatusHandler(
                    e,
                    "Dispute",
                    setActionButtonLoading
                  )
                }
              >
                Yes
              </LoadingButton>
            </div>
          </div>
        </div>
      </CustomModal>

      {/*---------- chat show Accepted modal --------------*/}
      <CustomModal
        show={chat}
        handleClose={() => setChat(false)}
        className={"special_charges_modal cstm_chat_modal"}
      >
        <div className="wrap_sc_status">
          <h4>Reviews</h4>
          <div className="wrap_list_data mt-4">
            <ul>
              {remarkListForModal?.length > 0 &&
                remarkListForModal?.map((el) => {
                  if (el?.userId === selfAuthId) {
                    return (
                      <li key={el?.uniqId} className="chat right_chat">
                        <p>{el?.remark || "------"}</p>
                        <span>
                          {el?.userType === "admin" ? "me" : el?.userType}
                        </span>
                      </li>
                    );
                  } else {
                    return (
                      <li key={el?.uniqId} className="chat left_chat">
                        <p>{el?.remark || "------"}</p>
                        <span>{el?.userType || "*****"}</span>
                      </li>
                    );
                  }
                })}
            </ul>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default WeightDiscrepancies;
